import { from_YYYYMMDDHHMMSS } from "../config/dateFormatting";
import { IVersionedObject, ISeatingContent, IBookingContent, IPriceModelContent, IReverseDutchAuctionPriceModelParameters } from "../planEatApi/PlanEatFacade";

export function isBookingDisabled(bookingId: string, seatings: IVersionedObject<ISeatingContent>[], bookings: IVersionedObject<IBookingContent>[], priceModels: IVersionedObject<IPriceModelContent>[]) {
    var isDisabled = false;
    bookings.forEach(booking => {
        if(booking.content.id=== bookingId){
            seatings.forEach(seating => {
                if(seating.content.id=== booking.content.seatingId){
                    priceModels.forEach(priceModel => {
                        if(priceModel.content.id=== seating.content.priceModelId){
                            // Parse parameters
                            var parameters: IReverseDutchAuctionPriceModelParameters = JSON.parse(priceModel.content.priceModelParameters)

                            // Correct for cutoff
                            var tmpSeatingTime = new Date(from_YYYYMMDDHHMMSS(seating.content.seatingStart))
                            tmpSeatingTime.setDate(tmpSeatingTime.getDate() - parameters.cutOffDaysBefore)
                            let [aHours,aMinutes] = parameters.cutOffTimeADay.split(":")
                            tmpSeatingTime.setHours(parseInt(aHours))
                            tmpSeatingTime.setMinutes(parseInt(aMinutes))

                            // Time differemce
                            var now = new Date()
                            var difference = tmpSeatingTime.getTime() - now.getTime();
                            var seconds = Math.floor(difference / 1000);
                            var minutes = Math.floor(seconds / 60);
                            var hours = Math.floor(minutes / 60);

                            isDisabled = (Math.sign(hours)=== -1);
                        }
                    })
                }
            })
        }
    })
    return isDisabled;
}